<template>
  <v-container id="reportList">
    <header
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      "
    >
      <div
        style="
          border-bottom: 1px solid #aaa;
          width: 100%;
          text-align: center;
          margin-bottom: 10px;
        "
      >
        <h2 style="font-weight: 400">{{ $store.getters.getAppName }}</h2>
      </div>
      <img
        :src="
          prefecture.prefecture_logo
            ? 'https://api.sigfrotagov.com.br/uploads/' + prefecture.prefecture_logo?.replace('https://api.sigfrotagov.com.br/uploads/', '')
            : require('@/assets/no-image.jpg')
        "
        :alt="prefecture.social_name ? prefecture.social_name : ''"
        style="width: 30%; padding: 1%"
      />
      <h1 style="font-weight: 400">
        {{
          prefecture.prefecture_social_name
            ? prefecture.prefecture_social_name
            : ""
        }}
      </h1>
      <!-- <h3 style="font-weight: 400; margin-bottom: 10px">
        Fornecedor:
        {{ provider && provider.provider_name ? provider.provider_name : "" }}
      </h3> -->
      <h4>
        Período de: {{ convertDate(filter.startDate) }} até
        {{ convertDate(filter.endDate) }}
      </h4>
    </header>
    <table
      class="table"
      style="
        border-collapse: collapse;
        border: 1px solid rgb(214, 214, 214);
        padding: 20px;
        margin-top: 20px;
        width: 100%;
      "
      v-for="(value, i) in data.secretariarts"
      :key="i"
    >
      <tbody>
        <tr style="background: gray">
          <td style="padding: 5px; font-weight: bold; color: #fff">SETOR</td>
        </tr>
        <tr>
          <td style="padding: 5px">{{ value.sec_name }}</td>
        </tr>
        <tr>
          <td>
            <table
              class="table"
              style="
                border-collapse: collapse;
                border: 1px solid rgb(214, 214, 214);
                width: 100%;
              "
            >
              <thead>
                <tr
                  style="
                    border: 1px solid rgb(214, 214, 214);
                    text-align: center;
                  "
                >
                  <th
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 5px;
                      text-align: center;
                      background: gray;
                      color: #fff;
                    "
                  >
                    SUBSETOR
                  </th>
                  <th
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 5px;
                      text-align: center;
                      background: gray;
                      color: #fff;
                    "
                  >
                    VEICULO
                  </th>
                  <th
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 5px;
                      text-align: center;
                      background: gray;
                      color: #fff;
                    "
                  >
                    MODELO
                  </th>
                  <th
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 5px;
                      text-align: center;
                      background: gray;
                      color: #fff;
                    "
                  >
                    PLACA
                  </th>
                  <th
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 5px;
                      text-align: center;
                      background: gray;
                      color: #fff;
                    "
                  >
                    COMBUSTÍVEL
                  </th>
                  <th
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 5px;
                      text-align: center;
                      background: gray;
                      color: #fff;
                    "
                  >
                    NFE
                  </th>
                  <th
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 5px;
                      text-align: center;
                      background: gray;
                      color: #fff;
                    "
                  >
                    PREÇO UNITÁRIO
                  </th>
                  <th
                    style="
                      width: 140px;
                      border: 1px solid rgb(214, 214, 214);
                      padding: 5px;
                      text-align: center;
                      background: gray;
                      color: #fff;
                    "
                  >
                    LITROS
                  </th>
                  <th
                    style="
                      width: 140px;
                      border: 1px solid rgb(214, 214, 214);
                      padding: 5px;
                      text-align: center;
                      background: gray;
                      color: #fff;
                    "
                  >
                    TOTAL
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, i) in value.nfes" :key="i">
                  <td
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 8px;
                      text-align: center;
                    "
                  >
                    {{ d.subsec_desc ? d.subsec_desc : "---" }}
                  </td>
                  <td
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 8px;
                      text-align: center;
                    "
                  >
                    {{ d.brand_desc ? d.brand_desc : "" }}
                  </td>
                  <td
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 8px;
                      text-align: center;
                    "
                  >
                    {{ d.model_desc ? d.model_desc : "" }}
                  </td>
                  <td
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 8px;
                      text-align: center;
                    "
                  >
                    {{ d.vehicle_board ? d.vehicle_board : "" }}
                  </td>
                  <td
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 8px;
                      text-align: center;
                    "
                  >
                    {{ d.item_description_desc ? d.item_description_desc : "" }}
                  </td>
                  <td
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 8px;
                      text-align: center;
                    "
                  >
                    {{ d.supply_coupon ? d.supply_coupon : "" }}
                  </td>
                  <td
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 8px;
                      text-align: center;
                    "
                  >
                    {{
                      d.supply_bidding_price
                        ? realMask(d.supply_bidding_price.toFixed(2))
                        : ""
                    }}
                  </td>
                  <td
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 8px;
                      text-align: center;
                    "
                  >
                    {{ d.supply_liters_stocked ? realMask(d.supply_liters_stocked.toFixed(2)) : "" }}
                  </td>
                  <td
                    style="
                      border: 1px solid rgb(214, 214, 214);
                      padding: 8px;
                      text-align: center;
                    "
                  >
                    {{ d.supply_bidding_value ? realMask(d.supply_bidding_value.toFixed(2)) : "" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <table
            class="table"
            style="
              border-collapse: collapse;
              border: 1px solid rgb(214, 214, 214);
              border-top: 0;
              width: 100%;
            "
          >
            <thead>
              <tr>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style="text-align: right; font-weight: bold; padding: 5px"
                ></td>
                <td
                  style="
                    text-align: right;
                    border-right: 1px solid rgb(214, 214, 214);
                    font-weight: bold;
                    padding: 5px;
                  "
                >
                  RESUMO:
                </td>
                <td
                  style="
                    text-align: center;
                    border-right: 1px solid rgb(214, 214, 214);
                    font-weight: bold;
                    padding: 5px;
                    width: 140px;
                  "
                >
                  {{
                    value.subtotals.liters
                      ? realMask(Number(value.subtotals.liters).toFixed(2))
                      : 0
                  }}
                </td>
                <td
                  style="
                    text-align: center;
                    border-right: 1px solid rgb(214, 214, 214);
                    font-weight: bold;
                    padding: 5px;
                    width: 140px;
                  "
                >
                  {{
                    value.subtotals.value
                      ? realMask(Number(value.subtotals.value).toFixed(2))
                      : 0
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </tr>
      </tbody>
    </table>
    <div style="width: 100%; margin-top: 20px">
      <div style="display: flex; justify-content: space-between">
        <table
          class="table"
          style="
            border-collapse: collapse;
            border: 1px solid rgb(214, 214, 214);
            width: 100%;
          "
        >
          <thead>
            <tr
              style="border: 1px solid rgb(214, 214, 214); text-align: center"
            >
              <th
                style="
                  width: 15%;
                  border: 1px solid rgb(214, 214, 214);
                  padding: 5px;
                  text-align: center;
                  background: gray;
                  color: #fff;
                "
              >
                RESUMO
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <table
                  class="table"
                  style="
                    border-collapse: collapse;
                    border: 1px solid rgb(214, 214, 214);
                    width: 100%;
                  "
                >
                  <thead>
                    <tr
                      style="
                        width: 100%;
                        border: 1px solid rgb(214, 214, 214);
                        text-align: center;
                      "
                    >
                      <th
                        style="
                          width: 25%;
                          border: 1px solid rgb(214, 214, 214);
                          padding: 5px;
                          text-align: center;
                          background: #ddd;
                        "
                      >
                        ITEM
                      </th>
                      <th
                        style="
                          width: 25%;
                          border: 1px solid rgb(214, 214, 214);
                          padding: 5px;
                          text-align: center;
                          background: #ddd;
                        "
                      >
                        LITROS
                      </th>
                      <th
                        style="
                          width: 25%;
                          border: 1px solid rgb(214, 214, 214);
                          padding: 5px;
                          text-align: center;
                          background: #ddd;
                        "
                      >
                        TOTAL
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(res, t) in data.resume" :key="t">
                      <td
                        style="
                          border: 1px solid rgb(214, 214, 214);
                          text-align: center;
                          padding: 5px;
                        "
                      >
                        {{ res.item_description_desc }}
                      </td>
                      <td
                        style="
                          border: 1px solid rgb(214, 214, 214);
                          text-align: center;
                          padding: 5px;
                        "
                      >
                        {{
                          res.subTotalLiters
                            ? realMask(res.subTotalLiters.toFixed(2))
                            : 0
                        }}
                      </td>
                      <td
                        style="
                          border: 1px solid rgb(214, 214, 214);
                          text-align: center;
                          padding: 5px;
                        "
                      >
                        {{
                          res.subTotalValues
                            ? realMask(res.subTotalValues.toFixed(2))
                            : 0
                        }}
                      </td>
                    </tr>
                    <tr style="width: 100%">
                      <td style="text-align: center; padding: 5px"></td>
                      <td
                        style="
                          border: 1px solid rgb(214, 214, 214);
                          text-align: center;
                          padding: 5px;
                        "
                      >
                        {{
                          data.totals.liters
                            ? realMask(data.totals.liters.toFixed(2))
                            : 0
                        }}
                      </td>
                      <td
                        style="
                          border: 1px solid rgb(214, 214, 214);
                          text-align: center;
                          padding: 5px;
                        "
                      >
                        {{
                          data.totals.value
                            ? realMask(data.totals.value.toFixed(2))
                            : 0
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import helpers from "@/mixins/helpers";
export default {
  props: ["data", "filter", "prefecture", "provider"],
  mixins: [helpers],
  methods: {
    initialize() {
      this.helpers;
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  border: 1px solid rgb(17, 17, 17);
}
</style>